import type { CopyValue } from "./types.ts";

export const getCopyString = <
  ArgumentType extends
    | [
      copyKey: string,
      CopyArguments: Record<string, string | number> | number,
    ]
    | [copyKey: string],
>({ copy, onError, debug }: {
  copy: Record<ArgumentType[0], CopyValue>;
  onError?: (reason: "empty-key" | "missing-key", key: string) => unknown;
  debug: boolean;
}) =>
(...[key, values = {}]: ArgumentType): string => {
  if (debug) {
    return key;
  }

  if (!key) {
    onError?.("empty-key", key);
    return "";
  }
  const copyValue = copy[key as ArgumentType[0]];
  if (!copyValue) {
    onError?.("missing-key", key);
    return "";
  }
  let str: string;
  if (typeof copyValue === "string") {
    str = copyValue;
  } else {
    const pluralValue = typeof values === "number"
      ? values
      : Number(Object.values(values)[0]);
    if (pluralValue === 1) {
      str = copyValue.one;
    } else {
      str = copyValue.other;
    }
  }
  for (const [key, value] of Object.entries(values)) {
    str = str.replaceAll(`{${key}}`, String(value));
  }
  return str;
};
